<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="$device.large ? `top` : `left`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :sm="6">
            <el-form-item :label="$t('매장')">
              <!-- 조건이 바뀌면 **1페이지로 돌아간다** — 3페이지를 보다 매장·카테고리를 바꾸면 그 3페이지는
                   다른 결과 집합의 3페이지라 흔히 빈 표가 온다([pagedListMixin.searchFirstPage]) -->
              <StorePicker v-model="searchForm.storeCd" :options="store" @change="searchFirstPage" />
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item :label="$t('카테고리')">
              <el-select v-model="searchForm.categoryCd" @change="searchFirstPage">
                <el-option key="0" :label="$t('전체')" :value="null"></el-option>
                <el-option
                  v-for="item in category"
                  :key="item.categoryCd"
                  :label="item.categoryNmLan"
                  :value="item.categoryCd"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item :label="$t('메뉴명')">
              <el-input v-model="searchForm.smenuNm" @keyup.enter.native="searchFirstPage" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item :label="$t('사용 가능 여부')">
              <combo
                :data="mainVue.code.useYn"
                :label="$t('전체')"
                :model="searchForm.useYn"
                @change="searchForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button
        v-if="checkAuthActionAccess('SmenuSearch')"
        :size="size"
        @click="searchFirstPage"
        icon="el-icon-search"
        >{{ $t('검색') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('SmenuAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('SmenuUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('SmenuDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('SmenuUse')"
        :size="size"
        @click="use"
        icon="el-icon-check"
        :disabled="btn.delDisabled"
        >{{ $t('사용') }}</el-button
      >

      <el-button
        v-if="checkAuthActionAccess('SmenuSearch')"
        :size="size"
        @click="showImg = !showImg"
        icon="el-icon-picture-outline">
        {{ !showImg ? this.$t('이미지 보기') : this.$t('이미지 숨김') }}
      </el-button>

      <template v-if="checkAuthActionAccess('SmenuAdd') || checkAuthActionAccess('SmenuUp')">
        <el-popover placement="right" width="600" trigger="click">
          <div style="overflow: scroll" :style="{ height: tableHeight > 620 ? 'auto' : tableHeight + 50 + 'px' }">
            <div style="margin: 10px">
              <label>{{ $t('매장명') }}</label
              >:&nbsp;&nbsp;
              <StorePicker :size="size" v-model="storeCd" :options="store" />
            </div>

            <el-divider></el-divider>

            <div style="margin: 10px">
              <div>
                {{
                  $t(
                    '* 양식 파일 첫줄 해더 이름 기준으로 데이타 업로드 됩니다. 수정 하시면 업로드 안되거나 오류 발생 할 수 있습니다.'
                  )
                }}
              </div>
            </div>
            <el-button :size="size" @click="downExcel" icon="el-icon-download" style="margin-left: 10px">{{
              $t('업로드 양식 다운로드')
            }}</el-button>

            <el-divider></el-divider>

            <div style="margin: 10px">
              <div>
                {{
                  $t(
                    `* 카테고리명은 이미 등록된 카테고리명을 입력 하시면 자동 매칭 됩니다. 등록된 카테고리명이 없거나 기타 문제로 매칭 안될경우 첫 순번의 카테고리로 설정 됩니다.\n등록된 카테고리 정보가 하나도 없을 경우 메뉴 등록 안됩니다. 콤마로 여러개의 카테고리를 구분 할 수 있습니다.`
                  )
                }}
              </div>
              <div>
                {{
                  $t(
                    `* 옵션명은 이미 등록된 옵션명을 입력 하시면 자동 매칭 됩니다. 등록된 옵션명이 없거나 기타 문제로 매칭 안될경우 설정 되지 않습니다.\n옵션명을 공란으로 둔채로 업로드시, 옵션에 첫번째로 등록한 옵션이 자동으로 입력되어 저장됩니다.\n콤마로 여러개의 옵션명을 구분 할 수 있습니다.`
                  )
                }}
              </div>
              <div>
                {{
                  $t(
                    '* 메뉴 데이터 업로드를 추가적으로 할 경우, 추가할 메뉴만 양식에 적어 업로드하여야 데이터 중복 등록이 되지 않습니다.'
                  )
                }}
              </div>
              <div>
                {{
                  $t(
                    '* 업로드된 메뉴는 사용 불가능 상태로 설정 됩니다. 메뉴 설정 완료 후 사용 가능 상태로 설정 하여 주십시오.'
                  )
                }}
              </div>
            </div>

            <el-upload
              :show-file-list="false"
              :action="getUpDataUrl"
              with-credentials
              accept="application/vnd.ms-excel"
              :headers="uploadHeaders"
              style="display: inline; margin-left: 10px"
              :on-success="upSuccess"
              :on-error="upError">
              <el-button :size="size" icon="el-icon-upload">{{ $t('메뉴 데이타 업로드') }}</el-button>
            </el-upload>

            <el-divider></el-divider>

            <div style="margin: 10px">
              <div>
                {{
                  $t(
                    '* 이미지 파일명을 메뉴명과 동일 하게 설정 하고 업로드 하시면 해당 메뉴 이미지를 업데이트 하게 됩니다.'
                  )
                }}
              </div>
              <div>{{ $t('* 이미지 사이즈는 200x150필셀을 규격을 준수 하여주십시오.') }}</div>
              <div>{{ $t('* 이미지 파일를 압축 한다음 압축파일을 업로드 하십시오.') }}</div>
            </div>

            <el-upload
              :show-file-list="false"
              :action="getUpImgUrl"
              with-credentials
              accept="application/x-zip-compressed"
              :headers="uploadHeaders"
              style="display: inline; margin-left: 10px"
              :on-success="upSuccess"
              :on-error="upError">
              <el-button :size="size" icon="el-icon-upload">{{ $t('메뉴 이미지 업로드') }}</el-button>
            </el-upload>
          </div>

          <el-button slot="reference" :size="size" icon="el-icon-upload">{{ $t('메뉴 업로드') }}</el-button>
        </el-popover>
      </template>
    </div>

    <!-- 리스트 -->
    <el-table
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      @row-click="handleRowClick"
      @select="handleRowChecked"
      @select-all="handleRowChecked"
      @sort-change="handleSortChange">
      <el-table-column
        :label="totalElements.toString()"
        type="index"
        width="55"
        align="center"
        label-class-name="data_cnt"
        :index="indexMethod"></el-table-column>
      <el-table-column type="selection" width="45" align="center"></el-table-column>

      <el-table-column :label="$t('이미지')" prop="smenuImg" width="62" v-if="showImg">
        <template slot-scope="scope">
          <fallback-image
            style="width: 40px; height: 30px"
            :src="resolvImage(scope.row.smenuImg)"
            fit="fill"></fallback-image>
        </template>
      </el-table-column>

      <!-- 정렬은 **서버**가 한다(`sortable="custom"`) — 페이징된 목록에서 `sortable` 은 「이 페이지 안에서만」이라
           사람이 본 순서와 서버가 고른 한 장이 서로 다른 말을 한다. 그래서 서버가 정렬할 수 있는 열에만 머리글을
           둔다: 조립 문자열 열(재료·옵션·할인)과 판매 정지 두 열은 정렬 축에서 뺐다 — 누를 수 있는데 이 장만
           다시 늘어놓는 머리글은 없느니만 못하다 -->
      <el-table-column :label="$t('메뉴명')" prop="smenuNmLan" min-width="200" sortable="custom" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-button type="text" @click="clickUp(scope.row)"
            ><i class="el-icon-edit-outline"></i>&nbsp;{{ scope.row.smenuNmLan }}</el-button
          >
        </template>
      </el-table-column>
      <el-table-column :label="$t('표시 순서')" prop="ord" min-width="130" align="center" sortable="custom">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.ord"
            @change="handleChangeOrd(scope.row)"
            :min="1"
            :max="99999"
            size="mini"
            style="width: 90px"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('카테고리명')"
        prop="categorysNm"
        min-width="200"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('판매 방식')"
        prop="salesTpNms"
        min-width="140"
        align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column :label="$t('메뉴 재료')" prop="stuffsNm" min-width="200" show-overflow-tooltip></el-table-column>
      <!-- 옵션명은 서버가 **요약형**(앞 5개 + 「외 n개」)으로 내린다 — 셀은 받은 문자열을 그대로 그린다 -->
      <el-table-column
        :label="$t('메뉴 옵션')"
        prop="smenuOptsNm"
        min-width="200"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('메뉴 할인')"
        prop="discountsNm"
        min-width="200"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('원가')"
        prop="cost"
        min-width="100"
        align="right"
        sortable="custom"
        :formatter="mainVue.formatterPrice"></el-table-column>
      <el-table-column
        :label="$t('단가')"
        prop="priceLan"
        min-width="100"
        align="right"
        sortable="custom"
        :formatter="mainVue.formatterPrice"></el-table-column>
      <el-table-column
        :label="$t('사용 가능 여부')"
        prop="useYn"
        min-width="110"
        align="center"
        sortable="custom"
        :formatter="mainVue.formatterCode"></el-table-column>
      <el-table-column
        :label="$t('부가세')"
        prop="vatTpNm"
        min-width="110"
        align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('봉사료')"
        prop="serviceCostTpNm"
        min-width="110"
        align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('바코드')"
        prop="barcode"
        min-width="110"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column :label="$t('판매 정지')" prop="stopSelling" min-width="100" align="center">
        <template slot-scope="scope">{{ scope.row.stopSelling ? 'O' : '' }}</template>
      </el-table-column>
      <el-table-column
        :label="$t('판매 정지 사유')"
        prop="stopReasonNm"
        min-width="200"
        show-overflow-tooltip></el-table-column>
      <!--			<el-table-column :label="$t('키오스크 노출 여부')" 	prop="availableInKiosk" 	min-width="150" align="center" sortable>-->
      <!--				<template slot-scope="scope">{{ scope.row.availableInKiosk ? 'O' : '' }}</template>-->
      <!--			</el-table-column>-->
      <!--			<el-table-column :label="$t('주방 프린터 출력')" 	prop="availableKitchenPrinter" 	min-width="150" align="center" sortable>-->
      <!--				<template slot-scope="scope">{{ scope.row.availableKitchenPrinter ? 'O' : '' }}</template>-->
      <!--			</el-table-column>-->
      <!--			<el-table-column :label="$t('재고 관리 사용')" 	prop="availableSmenuStockManagement" 	min-width="150" align="center" sortable>-->
      <!--				<template slot-scope="scope">{{ scope.row.availableSmenuStockManagement ? 'O' : '' }}</template>-->
      <!--			</el-table-column>-->
      <!--			<el-table-column :label="$t('재고 없을때 판매')" 	prop="availableSellWithoutStock" 	min-width="150" align="center" sortable>-->
      <!--				<template slot-scope="scope">{{ scope.row.availableSellWithoutStock ? 'O' : '' }}</template>-->
      <!--			</el-table-column>-->
      <!--			<el-table-column :label="$t('재고')" 		prop="stock" 	min-width="100" align="right" sortable :formatter="mainVue.formatterPrice"></el-table-column>-->
      <el-table-column
        :label="$t('키오스크 라벨')"
        prop="kioskLabelTpNm"
        min-width="110"
        align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column :label="$t('설명')" prop="smenuDesc" min-width="200" show-overflow-tooltip></el-table-column>
    </el-table>
    <list-pagination
      :search-form="searchForm"
      :total="totalElements"
      @page-change="handlePageChange"
      @size-change="handleSizeChange"></list-pagination>

    <!-- 입력 팝업 -->
    <el-dialog :title="inputForm.title" :visible.sync="dialogFormVisible" fullscreen>
      <el-form
        :model="inputForm"
        label-width="140px"
        :label-position="$device.mobile ? 'top' : 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-tabs v-model="activiTabSmenu">
          <el-tab-pane :label="$t('기본 정보')" name="info">
            <el-row :gutter="20">
              <el-col :md="inputForm.smenuInfos.length > 0 ? 16 : 24">
                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('메뉴 이미지')" :error="formError['smenuImgFile']" required>
                      <el-upload
                        action=""
                        class="avatar-uploader"
                        accept="image/*"
                        :show-file-list="false"
                        :auto-upload="false"
                        :on-change="smenuImgChange"
                        ref="fileRef">
                        <fallback-image
                          native
                          v-if="inputForm.smenuImgFile !== ''"
                          :src="this.resolvImage(inputForm.smenuImgFile)"
                          class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">
                          {{ $t('200x150 픽셀 이미지만 업로드 가능합니다.') }}
                        </div>
                      </el-upload>
                    </el-form-item>
                  </el-col>

                  <el-col :md="12">
                    <el-form-item :label="$t('매장')" required>
                      <StorePicker
                        v-if="'I' === inputForm.statu"
                        v-model="inputForm.store.storeCd"
                        :options="store"
                        @change="storeInputSelect" />
                      <span v-else class="show_cd">{{ inputForm.store.storeNmLan }}</span>
                    </el-form-item>

                    <el-form-item :label="$t('메뉴명')" :error="formError.smenuNm" required>
                      <el-input v-model="inputForm.smenuNm" maxlength="50" clearable show-word-limit>
                        <el-button
                          v-if="lans.length > 1"
                          slot="append"
                          :size="size"
                          @click="dictionaryDialogFormVisible = true"
                          icon="el-icon-search"
                          >{{ $t('다국어 조회') }}</el-button
                        >
                      </el-input>

                      <!-- 사전 선택 -->
                      <DictionaryDialog
                        :visible="dictionaryDialogFormVisible"
                        @close="dictionaryDialogFormVisible = false"
                        @selectDictionary="selectDictionary" />
                    </el-form-item>

                    <el-form-item :label="$t('표시 순서')" :error="formError.ord" required>
                      <el-input-number v-model="inputForm.ord" :min="1" :max="99999"></el-input-number>
                    </el-form-item>

                    <el-form-item
                      v-if="!inputForm.availableMarketPrice"
                      :label="$t('원가')"
                      :error="formError.cost"
                      required>
                      <el-input-number
                        v-model="inputForm.cost"
                        :step="100"
                        :min="0"
                        :max="90000000"
                        style="width: 200px"></el-input-number>
                    </el-form-item>

                    <el-form-item
                      v-if="!inputForm.availableMarketPrice"
                      :label="$t('단가')"
                      :error="formError.price"
                      required>
                      <el-input-number
                        v-model="inputForm.price"
                        :step="100"
                        :min="0"
                        :max="90000000"
                        style="width: 200px"></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('메뉴 옵션')">
                      <opt-select
                        :data="smenuOpt"
                        :model="inputForm.smenuOpts"
                        @change="inputForm.smenuOpts = $event"></opt-select>
                    </el-form-item>
                  </el-col>
                  <el-col :md="12">
                    <el-form-item :label="$t('카테고리')" :error="formError.categorys" required>
                      <category-combo
                        :data="category"
                        :model="inputForm.categorys"
                        @change="inputForm.categorys = $event"></category-combo>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('칼로리')" :error="formError.calorie">
                      <el-input-number v-model="inputForm.calorie" :step="10" :min="0" :max="999999"></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :md="12">
                    <el-form-item
                      v-if="!inputForm.availableMarketPrice"
                      :label="$t('할인 설정')"
                      :error="formError.discounts">
                      <discount-combo
                        :data="discount"
                        :label="$t('전체')"
                        :model="inputForm.discounts"
                        @change="inputForm.discounts = $event"></discount-combo>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('판매 방식')" :error="formError.salesTps" required>
                      <mcode-combo
                        :data="salesTp"
                        :model="inputForm.salesTps"
                        @change="inputForm.salesTps = $event"></mcode-combo>
                    </el-form-item>
                  </el-col>

                  <el-col :md="12">
                    <el-form-item :label="$t('사용 가능 여부')" required>
                      <combo
                        :data="mainVue.code.useYn"
                        :model="inputForm.useYn"
                        @change="inputForm.useYn = $event"></combo>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('싯가 적용 여부')">
                      <el-switch v-model="inputForm.availableMarketPrice"></el-switch>
                    </el-form-item>
                  </el-col>

                  <el-col :md="12">
                    <el-form-item :label="$t('성인 인증 필요')">
                      <el-switch v-model="inputForm.requiresAdultVerification"></el-switch>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item :label="$t('설명')" :error="formError.smenuDesc">
                  <el-input v-model="inputForm.smenuDesc" type="textarea" maxlength="250" show-word-limit></el-input>
                </el-form-item>

                <!-- 원산지 표기·알레르기 표기·메뉴 태그 — 점주 「메뉴 관리」와 같은 패널이다(대행 계정도 메뉴 원산지를 고친다, R-S) -->
                <SmenuLabelingPanel v-model="inputForm" :formError="formError" />
              </el-col>

              <el-col :md="8" v-if="inputForm.smenuInfos.length > 0">
                <el-tabs v-model="activiTab">
                  <el-tab-pane
                    v-for="(item, index) in inputForm.smenuInfos"
                    :key="item.lanTp.id"
                    :label="item.lanTp.nm"
                    :name="item.lanTp.id">
                    <el-form-item
                      :label="$t('메뉴명')"
                      :error="formError['smenuInfos[' + index + '].smenuInfoNm']"
                      required>
                      <el-input
                        v-model="inputForm.smenuInfos[index].smenuInfoNm"
                        maxlength="50"
                        clearable
                        show-word-limit></el-input>
                    </el-form-item>

                    <el-form-item
                      :label="$t('단가')"
                      :error="formError['smenuInfos[' + index + '].price']"
                      required
                      v-if="inputForm.store.internationalPayYn">
                      <el-input-number
                        v-model="inputForm.smenuInfos[index].price"
                        :min="0"
                        :max="90000000"
                        style="width: 200px"></el-input-number>
                    </el-form-item>
                  </el-tab-pane>
                </el-tabs>
              </el-col>
            </el-row>
          </el-tab-pane>

          <el-tab-pane :label="$t('재료 설정')" name="stuff">
            <StuffSettingPanel v-model="inputForm" :stuff="stuff" />
          </el-tab-pane>

          <el-tab-pane :label="$t('포스 전용 설정')" name="pos">
            <el-row :gutter="20">
              <el-col :md="24">
                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('부가세')" :error="formError.vatTp" required>
                      <code-combo
                        :data="vatTp"
                        :model="inputForm.vatTp"
                        @change="inputForm.vatTp = $event"></code-combo>
                    </el-form-item>
                  </el-col>
                  <el-col :md="12">
                    <el-form-item :label="$t('봉사료')" :error="formError.serviceCostTp">
                      <code-combo
                        :data="serviceCostTp"
                        :model="inputForm.serviceCostTp"
                        @change="inputForm.serviceCostTp = $event"></code-combo>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('바코드')" :error="formError.barcode">
                      <el-input v-model="inputForm.barcode" maxlength="30" clearable show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="12">
                    <el-form-item :label="$t('키오스크 라벨')" :error="formError.kioskLabelTp" required>
                      <code-combo
                        :data="kioskLabelTp"
                        :model="inputForm.kioskLabelTp"
                        @change="inputForm.kioskLabelTp = $event"></code-combo>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('주방 프린터 출력')">
                      <el-switch v-model="inputForm.availableKitchenPrinter"></el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :md="12">
                    <el-form-item :label="$t('재고 관리 사용')">
                      <el-switch v-model="inputForm.availableSmenuStockManagement"></el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :md="12">
                    <el-form-item :label="$t('재고 없을 때 판매')">
                      <el-switch v-model="inputForm.availableSellWithoutStock"></el-switch>
                    </el-form-item>
                  </el-col>

                  <el-col :md="12">
                    <el-form-item :label="$t('재고')" :error="formError.stock">
                      <el-input-number
                        v-model="inputForm.stock"
                        :step="100"
                        :min="0"
                        :max="90000000"
                        style="width: 200px"></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('판매 정지 여부')">
                      <el-switch v-model="inputForm.stopSelling"></el-switch>
                    </el-form-item>
                  </el-col>
                  <!--									<el-col :md="12">-->
                  <!--										<el-form-item :label="$t('키오스크 노출 여부')">-->
                  <!--											<el-switch v-model="inputForm.availableInKiosk"></el-switch>-->
                  <!--										</el-form-item>-->
                  <!--									</el-col>-->
                  <el-col :md="12">
                    <el-form-item :label="$t('판매 정지 사유')">
                      <code-combo
                        :data="stopReason"
                        :model="inputForm.stopReason"
                        @change="inputForm.stopReason = $event"
                        :disabled="!inputForm.stopSelling"></code-combo>
                    </el-form-item>
                  </el-col>
                  <el-col :md="12">
                    <el-form-item :label="$t('기타 사유')" :error="formError.otherReason">
                      <el-input
                        v-model="inputForm.otherReason"
                        maxlength="50"
                        clearable
                        show-word-limit
                        :disabled="
                          !inputForm.stopSelling || null == inputForm.stopReason || 'OTHER' != inputForm.stopReason.val
                        "></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button icon="el-icon-check" :size="size" @click="save" :disabled="btn.saveDisabled">{{
          $t('저장')
        }}</el-button>
        <el-button icon="el-icon-close" :size="size" @click="closeDialogVisible = true">{{ $t('닫기') }}</el-button>
        <el-dialog
          title="Warning"
          :visible.sync="closeDialogVisible"
          width="300px"
          :modal="false"
          :modal-append-to-body="false"
          :append-to-body="true"
          center>
          <span>정말로 페이지를 닫으시겠습니까?</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialogVisible = false">아니요</el-button>
            <el-button
              type="primary"
              @click="
                closeDialogVisible = false
                dialogFormVisible = false
              "
              >예</el-button
            >
          </span>
        </el-dialog>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 대리점
import StorePicker from '@/components/store/StorePicker.vue'
import DictionaryDialog from '@/components/dictionary/DictionaryDialog.vue'
import SmenuLabelingPanel from '@/components/store/SmenuLabelingPanel.vue'
import StuffSettingPanel from '@/components/store/StuffSettingPanel.vue'
import mainVueMixin from '@/mixins/mainVueMixin'
import pagedListMixin from '@/mixins/pagedListMixin'
import { util } from '@/mixins/utilMixin'
import { initData } from '@/utils/constants'
import { ALL_ROWS_PAGE_SIZE, pageRows, withPaging } from '@/utils/pagedList'
import { STORE_OPTIONS_API, firstStoreOf, storeLansOf, storeOptionsOf, storeOptionsQuery } from '@/utils/storeOptions'
import storeOptionResolver from '@/mixins/storeOptionResolver'
import { smenuLabelingBlank } from '@/utils/smenuLabeling'
import { syncLangValue } from '@/utils/syncLangValue'
import { SOLD_OUT_PLATFORM_DEFAULT, deliveryDeleteHidesNote } from '@/utils/deliveryMenuNotes'
import { DELIVERY_MENU_ACTIONS } from '@/utils/deliveryMenuSync'
import { downloadExcelFile } from '@/utils/downloadExcelFile'
import { mapGetters } from 'vuex'

export default {
  mixins: [mainVueMixin, pagedListMixin, storeOptionResolver],

  components: {
    StorePicker,
    DictionaryDialog,
    SmenuLabelingPanel,
    StuffSettingPanel,
  },

  data: function () {
    var data = initData()
    data.url = '/smenu'

    data.store = []
    data.category = []
    data.salesTp = []
    data.smenuOpt = []
    data.stuff = []
    data.discount = []
    data.stopReason = []
    data.vatTp = []
    data.kioskLabelTp = []
    data.serviceCostTp = []
    data.serviceRate = 0
    data.activiTab = ''
    data.activiTabSmenu = 'info'

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    // 다국어 사전 용
    data.lans = []
    data.popTableData = []

    data.dictionaryDialogFormVisible = false
    data.searchText = ''

    // 이미지 표시 여부
    data.showImg = false

    data.listTitle = this.$t('재료 리스트')
    data.dataTitle = this.$t('재료')
    data.listBtn = this.$t('제거')
    data.dataBtn = this.$t('설정')

    data.storeCd = null

    data.closeDialogVisible = false
    return data
  },
  created: function () {
    this.initStore()
    this.initSalesTp()
    this.initStopReason()
    this.initVatTp()
    this.initKioskLabelTp()
    this.initServiceCostTp()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    // ★ **단가 수정 이벤트 감지** — 매장 화면(`*ForStoreView`)과 **같은 규칙**이다 (§16.219⑤).
    //
    // 이 관리자 화면들에는 이 감지가 아예 없어서, 타국화폐 결제를 안 쓰는 매장에서 본 단가를
    // 고쳐도 **언어 탭 값이 옛 가격으로 남았다.** 매장 화면 세 곳만 고치고 여기를 빠뜨리면
    // 「어느 저장 경로로도」가 참이 되지 않는다 — 같은 메뉴를 두 화면에서 고칠 수 있다.
    //
    // 동기화 로직 자체는 `utils/syncLangValue` 한 곳이 소유한다(인덱스 루프를 다시 적지 않는다).
    'inputForm.price': function () {
      if (!this.inputForm.store.internationalPayYn) {
        syncLangValue(this.inputForm.smenuInfos, 'price', this.inputForm.price)
      }
    },
    formError: {
      deep: true,
      handler: function (newVal, oldVal) {
        // 벨리데이션 메세지가 값은 있는데 Vue에서 표시 안해주는 현상 처리 하기 위함
        setTimeout(
          function () {
            var tmp = this.inputForm.smenuNm
            this.inputForm.smenuNm = this.inputForm.smenuNm + ' '
            this.inputForm.smenuNm = tmp

            var i = 100

            var infoErrors = [
              'smenuImgFile',
              'smenuNm',
              'cost',
              'price',
              'ord',
              'categorys',
              'salesTps',
              'useYn',
              'smenuDesc',
            ]
            var stuffErrors = []
            var posErrors = ['vatTp', 'serviceCostTp', 'barcode', 'kioskLabelTp', 'otherReason']

            var infoError = 0
            var stuffError = 0
            var posError = 0

            for (let val in newVal) {
              if ('' != newVal[val]) {
                if (infoErrors.includes(val)) {
                  infoError++
                } else if (stuffErrors.includes(val)) {
                  stuffError++
                } else if (posErrors.includes(val)) {
                  posError++
                }
              }

              if (val.indexOf('smenuInfos') > -1) {
                if ('' != newVal[val]) {
                  if (i > val.replace(/[^0-9]*/g, '')) {
                    i = parseInt(val.replace(/[^0-9]*/g, ''))
                  }
                }
              }
            }

            if (100 != i) {
              this.activiTab = this.inputForm.smenuInfos[i].lanTp.id
            }

            if (infoError > 0) {
              this.activiTabSmenu = 'info'
            } else if (stuffError > 0) {
              this.activiTabSmenu = 'stuff'
            } else if (posError > 0) {
              this.activiTabSmenu = 'pos'
            }
          }.bind(this),
          500
        )
      },
    },
    'inputForm.stopSelling': function (newVal) {
      if (!newVal) {
        this.inputForm.stopReason = null
        this.inputForm.otherReason = ''
      } else {
        if (null == this.inputForm.stopReason || null == this.inputForm.stopReason.cd) {
          this.inputForm.stopReason = this.stopReason.length > 0 ? util.copyObj(this.stopReason[0]) : null
        }
      }
    },
    'inputForm.stopReason.val': function (newVal) {
      if ('OTHER' != newVal) {
        this.inputForm.otherReason = ''
      }
    },
    // 이전 이미지 초기화
    dialogFormVisible: function (newVal) {
      if (!newVal) {
        this.inputForm.smenuImgFile = ''
        this.$refs.fileRef.clearFiles()
      }
    },
    showImg: function () {
      this.$nextTick(function () {
        this.$refs.table?.doLayout()
      })
    },
  },
  computed: {
    // 직접 업로드(`el-upload`)가 싣는 CSRF 헤더 — 스토어가 지금 토큰에서 셈한다(서버가 받는 이름 한 곳)
    ...mapGetters({ uploadHeaders: 'auth/csrfHeaders' }),
    getUpDataUrl: function () {
      return `${this.APP_API_URL}/smenu/up/${this.storeCd}`
    },
    getUpImgUrl: function () {
      return `${this.APP_API_URL}/smenu/upImg/${this.storeCd}`
    },
  },
  methods: {
    // 검색 조건 초기화 — 페이징·정렬 축은 [withPaging] 이 붙인다(기본 50건·첫 페이지·서버 기본 정렬)
    initSearchForm: function () {
      return withPaging({
        storeCd: null,
        categoryCd: null,
        smenuNm: '',
        useYn: 'Y',
      })
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        title: '',
        smenuCd: 0,
        defaultLan: { id: '' },
        smenuNm: '',
        cost: 0,
        price: 0,
        smenuInfos: [],
        store: { storeCd: null, internationalPayYn: false },
        categorys: [],
        smenuOpts: [],
        stuffs: [],
        stuffsCds: [],
        discounts: [],
        ord: 0,
        useYn: 'Y',
        smenuImg: '',
        smenuImgFile: '',
        smenuDesc: '',
        calorie: 0,
        stopSelling: false,
        availableInKiosk: true,
        availableKitchenPrinter: true,
        availableSmenuStockManagement: false,
        availableSellWithoutStock: true,
        availableMarketPrice: false,
        requiresAdultVerification: false,
        stock: 0,
        stopReason: null,
        vatTp: null,
        kioskLabelTp: null,
        serviceCostTp: null,
        barcode: '',
        otherReason: '',
        salesTps: '',
        // 원산지 표기·알레르기 표기·메뉴 태그 — 키는 칸 묶음의 주인(`utils/smenuLabeling`)이 정한다
        ...smenuLabelingBlank(),
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        smenuNm: '',
        cost: '',
        price: '',
        ord: '',
        useYn: '',
        smenuImgFile: '',
        categorys: '',
        smenuDesc: '',
        otherReason: '',
        salesTps: '',
        vatTp: '',
        kioskLabelTp: '',
        serviceCostTp: '',
        barcode: '',
        ...smenuLabelingBlank(),
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].smenuCd
      }
    },
    // 매장 자동 검색 — 셀렉트 전용 경량 조회다. URL·조건은 [storeOptionsQuery] 한 곳이 소유한다
    initStore: function () {
      this.mainVue.$axios.search(
        STORE_OPTIONS_API,
        storeOptionsQuery(),
        function (result) {
          this.store = storeOptionsOf(result)

          // 매장이 하나도 없는 계정(사업장 없음)은 빈 셀렉트·빈 표가 옳다 — 매장 축 없는 목록 조회는
          // 서버가 거절하므로 조회 자체를 건너뛴다
          const first = firstStoreOf(this.store)
          if (first == null) return

          // 검색 칸의 기본 매장과 첫 조회는 [StorePicker] 가 소유한다(그 칸의 `change` → `searchFirstPage`)
          this.inputForm.store.storeCd = first.storeCd
          this.inputForm.store.internationalPayYn = first.internationalPayYn
          this.inputForm.defaultLan = first.defaultLan

          this.initStoreLans(first)

          this.initCategory(first.storeCd)
          this.initSmenuOpt(first.storeCd)
          this.initStuff(first.storeCd)
          this.initDiscount(first.storeCd)

          this.storeCd = first.storeCd
        }.bind(this)
      )
    },
    // 사전 조회를 위한 언어 정보 설정 — 순서(기본 언어가 맨 앞)는 [storeLansOf] 한 곳이 소유한다
    initStoreLans: function (store) {
      this.lans = storeLansOf(store)
    },
    // 고른 매장의 메타데이터를 폼에 적는다 — 진입점 둘(사람·씨앗)은 [storeOptionResolver] 가 갖고
    // 화면은 이 본문만 구현한다. 못 얻으면 아무것도 바꾸지 않는다
    applyStoreOption: async function (storeCd, pending) {
      this.initCategory(storeCd)
      this.initSmenuOpt(storeCd)
      this.initStuff(storeCd)
      this.initDiscount(storeCd)

      const option = await pending
      if (!option) return

      // 국제 화페 단위 결제 여부
      this.inputForm.store.internationalPayYn = option.internationalPayYn

      this.inputForm.defaultLan = option.defaultLan
      this.initStoreLans(option)

      // 수정 시 매장 다국어 삭제 시 카테고리도 다국어 지워줌
      var smenuInfosTmp = []

      if (this.inputForm.statu == 'U') {
        smenuInfosTmp = util.copyObj(this.inputForm.smenuInfos)
      }

      this.inputForm.smenuInfos = []

      for (var j = 0, jlen = option.lans.length; j < jlen; j++) {
        this.formError['smenuInfos[' + j + '].smenuInfoNm'] = ''
        this.formError['smenuInfos[' + j + '].price'] = ''

        var smenuInfoNm = ''
        var price = 0

        if (this.inputForm.statu == 'U') {
          for (var k = 0, klen = smenuInfosTmp.length; k < klen; k++) {
            if (smenuInfosTmp[k].lanTp.id == option.lans[j].id) {
              smenuInfoNm = smenuInfosTmp[k].smenuInfoNm
              price = smenuInfosTmp[k].price
            }
          }
        }

        this.inputForm.smenuInfos.push({
          lanTp: option.lans[j],
          smenuInfoNm: smenuInfoNm,
          price: price,
        })

        if (j === 0) {
          this.activiTab = option.lans[j].id
        }
      }

      // ★★ **새 언어 행은 0 으로 태어난다** (`I18N-ROW-SEED`) — 위 복사는 이전 행이 있을
      // 때만 값을 옮긴다. 기본값을 여기서 계산하지 않고 **동기화의 소유자**를 한 번 부른다
      // (`I18N-PRICE-LOOP` 가 없앤 「여섯 벌의 같은 계산」을 다시 만들지 않는다).
      // 타국화폐 결제 매장은 일부러 언어별 값을 따로 정하므로 건드리지 않는다.
      if (!this.internationalPayYn) {
        syncLangValue(this.inputForm.smenuInfos, 'price', this.inputForm.price)
      }
    },
    // 카테고리 데이타 조회
    initCategory: function (storeCd) {
      this.mainVue.$axios.search(
        '/category',
        { storeCd: storeCd, categoryNm: '', useYn: 'Y' },
        function (result) {
          this.category = result
        }.bind(this)
      )
    },
    // 옵션 데이타 조회 — 셀렉트라 **전량**이다([ALL_ROWS_PAGE_SIZE]): 다음 장으로 넘어갈 수단이 없어
    // 한 장이 곧 전부여야 하고, 51번째 옵션이 빠지면 오류가 아니라 「없는 옵션」으로 보인다
    initSmenuOpt: function (storeCd) {
      this.mainVue.$axios.search(
        '/smenuOpt',
        { storeCd: storeCd, smenuOptNm: '', useYn: 'Y', pageSize: ALL_ROWS_PAGE_SIZE },
        function (result) {
          this.smenuOpt = pageRows(result)
        }.bind(this)
      )
    },
    // 재료 데이타 조회
    initStuff: function (storeCd) {
      this.mainVue.$axios.search(
        '/stuff',
        { storeCd: storeCd, stuffNm: '', useYn: 'Y' },
        function (result) {
          this.stuff = result
        }.bind(this)
      )
    },
    // 할인 데이타 조회
    initDiscount: function (storeCd) {
      this.mainVue.$axios.search(
        '/discount/forMenu',
        { storeCd: storeCd },
        function (result) {
          this.discount = result
        }.bind(this)
      )
    },
    // 판매 정지 사유
    initStopReason: function () {
      this.mainVue.$axios.search(
        '/code/getCode/STOP_REASON',
        null,
        function (result) {
          this.stopReason = result
        }.bind(this)
      )
    },
    // 판매 방식 데이타 초기화
    initSalesTp: function () {
      this.mainVue.$axios.search(
        '/code/getCode/SALES_TP',
        null,
        function (result) {
          this.salesTp = result
        }.bind(this)
      )
    },
    // 부가세
    initVatTp: function () {
      this.mainVue.$axios.search(
        '/code/getCode/VAT_TP',
        null,
        function (result) {
          this.vatTp = result
        }.bind(this),
        false
      )
    },
    // 봉사료
    initServiceCostTp: function () {
      this.mainVue.$axios.search(
        '/code/getCode/SERVICE_COST_TP',
        null,
        function (result) {
          this.serviceCostTp = result
        }.bind(this),
        false
      )
    },
    // 키오스크 라벨 구분
    initKioskLabelTp: function () {
      this.mainVue.$axios.search(
        '/code/getCode/KIOSK_LABEL_TP',
        null,
        function (result) {
          this.kioskLabelTp = result
        }.bind(this),
        false
      )
    },
    // 추가
    add: function () {
      this.activiTabSmenu = 'info'
      this.inputForm = this.initInputForm()
      this.inputForm.title = this.$t('메뉴 추가')
      this.formError = this.initFormError()

      if (this.store.length > 0) {
        this.inputForm.store = { storeCd: util.copyObj(this.searchForm.storeCd) }
        this.storeSeedSelect(this.inputForm.store.storeCd)
      }

      this.inputForm.salesTps = this.salesTp
      this.inputForm.smenuImgFile =
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAACWCAYAAACb3McZAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABw9JREFUeNrsneF12kgQgOV7/m93YDowVwG4AnMVWKkgXAUWFQRXcHIFERUEKji5A+gAV0B2zsMFK5KQkJB2l+97b59jB2NJ7Lczs1pJV7vdLgCAfP7gEAAgCACCACAIAIIAIAgAggAgCACCACAIACAIAIIAIAgAggAgCACCACAIAIIAIAgAggAAggAgCACCACAIAIIAIAgAggAgCACCAACCACAIAIIAIAgAggAgCACCACAIAIIAIAgAIAgAggAgCACCACAIgMVccwj8JE3TgfkyNm2o7da0+5yXvsvLTdvq16V8HQ6HW45iEFztdjuOgj9SiAihaRPT7hq+3cq0RJqRZY0g4LIYIkXUghRFLEybG1GWCAKIUR5VoksSBUHcTaXigpqiC15Nm15CncIslntySMT4t0c5hCfT1mZbJkQQsEUMmYVa9ixGHi8mkkwRBPpOqUSOG0s30duUC0GQoy3eTBv7Jgk1CHK0xb1uK0U6IEeRJGa7YwSBLgry2DE59jzpTBuCwNmYBvbNVtXh2Ugy9uGD8Hqxoo7Eh4v11tIucclECStzPMaZ4ybHZ2TazPxfdPBzed2Piu8bS5roetF+7akYEx2FRwX/LytYZSFedMkL8c7MnX4GEYLYI8ZAc/fRkZdKbv+k+XJvJ7p0pP70oxO2ZaX7nByO1nos9gPFXU8fiaRascuD0LVHcpw66/NVU4c+5vBHDX53Y1pYlC5qp5xL06L5uaePRv52SJHef+Q4RY499zoKu8LbhwPVaimtIx6Cj4ujuuZJPx8E6ZG4RA65lmF20DYFr3s0H6QLa4o2p0Q7lamvkdzZtVrOp1h6TcSoYJSVFCTNhnwt4vOkijRn3hb8nVM6mLxfm9EpzG6fztZJJxzrj7Zak8QZSRLz2letv7okdFUSH2qQsECOwlFWO8o4Jy270feb5/za4MSaYdnivq6yaVVJ7bWPiNnjEPUgyI0MSnLcSbG6jR63BZ12ciwF0ciSJ4LN1zjEOftfVnv9Vltp8b7oYdudvHbE9QgyzKs5akwriiDZ2Z2RxfubHYGjChMTj3rCLj2QpI/OOqZIt+OgpzUKV4kyK2dGg9+j4tChznnn4myWj2fS08ZvkBlxS3jocNlKkynaW4si/hpBumNb8CEkTTpPRTnqSjevMeLnFroV9z+PtUWCJAjSb7SYBBXX/2jIv29xpD7WOUYNJRtk6ivpbI8VIk+SeZ8w+DX7l3a41Ma5FMvpGqQgvbmvcbeNvFmspcW7PMnsfxx8TGmXEeXULvuFnKOGUQ1BHOA152exnh8oG43DgtHX5hRgWlCALwoix99Gjnlmv8eB29eaIEhN5gX5+jJv6YikKXpZ6D85v7dp+ax329xlr9aT6KDTtn8Gv5bTfJHROitHyfECT2uQ/wpqWbJu/vk1R5Jv2qHSg4K8bPQMz7id4xxZT7mljCwhT7ITCfp9eiRqxkSPy4sggRaZRbn4zUG+XdY5Zg5dabise1dDleOJLn9hESSTiyfBaTNFny4trZPemY53bKo1PkPaJtJ/18gZlS2r0ZpjTuS4cEG0k4w1pZoG1a4NKb3oqAJVOt05o5KklXLB10L/TpoZMCaWibFGkP5FifSkXKgt7zyHdKbE8oK8Do/B8fMhCIIgn6LJ/nLTbCGc9rRYD1pYBkSRDghCBGlwhD9OADZZfHdb86Zmch+ttRbxEX38ZDYu3t3ExRRLUqcma5qkJvlR4/Uzx8SQlQWHtZUMKN9KXj8qOR8j51zauhvK0kWreQy0f3y6c6Tp4LZsV4IgUJeV6zl6Rd5dvB4dQXomb/mJp8SubriLgnQ9ynZSWO7v7qjf+ibOHEG6G3V9fWCkiPjs4X69cm9eaEN8eazy7AySSMR9aHNTg/JZsSyRy58LgtiXilRdR1ZVPFlVsGwxFazz8pnrj5fgTLpdUUQ6c+jJ7mwCDy7OQhD7JJHp0IUHuxL68EhoUixLO5emRacsVR+c+fmAVW7yMPPlMXdXu92O7mghjj4GWpBZK1/SRARBklZ5k1tS+vQZUIPYXY/IlJGkS+8uyBH4d4ITQZCknbQq6OcZj6RY8H+6NQg+VsTadvOFF49XNxBBHIoka40kL5ZskkS0v3yWgwjibjQRUeKgv+efS0o19TGlQhC/RImClpemHEGuX4l8OceBIJchiVyfH6oo54oocmZ/fkliIIi/qddEW1NZVjopkLi+4BBBIE+WgRb1Q21FN+6WYlumkrf6VaJEegn1BYIANIRpXgAEAUAQAAQBQBAABAFAEAAEAUAQAAQBAAQBQBAABAFAEAAEAUAQAAQBQBAABAFAEABAEAAEAUAQAAQBQBAABAFAEAAEAUAQAEAQAAQBQBAABAFAEAAEAUAQAAQBQBAABAEABAFAEAAEAUAQAAQBsJmfAgwAKvZ0aBqpdngAAAAASUVORK5CYII='

      // 순번 자동 — 서버에 「이 조건에서 가장 큰 `ord`」 한 행만 묻고 그 다음 수를 쓴다.
      // 화면이 가진 목록으로 세면 **지금 보고 있는 한 장**의 최댓값이라, 2페이지에 더 큰 값이
      // 있어도 모른 채 이미 쓰는 순번을 다시 내준다. 창은 답이 온 뒤에 연다(실패해도 열린다).
      this.fetchNextSequence(
        'ord',
        function (ord) {
          this.inputForm.ord = ord

          this.dialogFormVisible = true
          this.btn.saveDisabled = false
        }.bind(this)
      )
    },
    // 메뉴 클릭해서 수정
    clickUp: function (row) {
      this.handleRowClick(row)
      this.up()
    },
    // 수정
    up: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.smenuCd,
        function (result) {
          this.activiTabSmenu = 'info'
          result.statu = 'U'
          result.title = this.$t('메뉴 수정')
          result.smenuImgFile = result.smenuImg

          // 재료 설정
          result.stuffsCds = []
          for (var i = 0, len = result.stuffs.length; i < len; i++) {
            result.stuffsCds.push(result.stuffs[i].stuffCd)
          }

          this.inputForm = result

          this.formError = this.initFormError()

          this.stuff = [] // 체크상태 초기화 하기 위해서 재설정, 아래 함수에서 다시 설정 해줌
          this.storeSeedSelect(this.inputForm.store.storeCd)

          this.dialogFormVisible = true
          this.btn.saveDisabled = false
        }.bind(this)
      )
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchQuery(),
        function (result) {
          this.applyPage(result)
          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true

          this.formError = this.initFormError()
        }.bind(this)
      )
    },
    // 삭제 — 이 화면은 배달 링크를 읽지 않으므로 조건문으로 말한다(§16.302 · 문구는 utils/deliveryMenuNotes)
    del: function () {
      this.mainVue
        .$confirm(
          this.$t('메뉴 정보를 삭제 하시겠습니까?') + ' ' + this.$t(deliveryDeleteHidesNote(null)),
          this.mainVue.appMsg.systemAlterTitle,
          {
            confirmButtonText: this.$t('삭제'),
            cancelButtonText: this.$t('취소'),
            type: 'info',
          }
        )
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this)
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    // 반영
    use: function () {
      this.mainVue
        .$confirm(this.$t('메뉴 정보를 사용으로 설정 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('사용'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.up(
              this.url + '/use/' + this.checkedData.join(','),
              null,
              null,
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('사용 설정 성공') })
                // 필터를 바꿨으니 **1페이지부터** 다시 본다 — 3페이지는 다른 결과 집합의 3페이지다
                this.searchForm.useYn = 'Y'
                this.searchFirstPage()
              }.bind(this)
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('사용 취소') })
          }.bind(this)
        )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      // 재료 설정
      this.inputForm.stuffs = []
      for (var i = 0, len = this.inputForm.stuffsCds.length; i < len; i++) {
        for (var j = 0, jlen = this.stuff.length; j < jlen; j++) {
          if (this.inputForm.stuffsCds[i] == this.stuff[j].stuffCd) {
            this.inputForm.stuffs.push(this.stuff[j])
            break
          }
        }
      }

      for (var i = 0, len = this.inputForm.smenuInfos.length; i < len; i++) {
        this.formError['smenuInfos[' + i + '].smenuInfoNm'] = ''
        this.formError['smenuInfos[' + i + '].price'] = ''
      }

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          this.inputForm,
          this.formError,
          function (result) {
            this.afterSaved(this.$t('등록 성공'))
          }.bind(this)
        )
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputForm.smenuCd,
          this.inputForm,
          this.formError,
          function (result) {
            this.afterSaved(this.$t('수정 성공'))
          }.bind(this)
        )
      }
    },
    /**
     * ★★ **품절을 켠 저장이면 그 품절의 기한을 말한다** (`SOLDOUT-EXPIRY-MENU-AXIS-UNTOLD`).
     *
     * 배달앱 품절은 **그 앱의 기본 품절**로 나가고 기한이 지나면 스스로 풀린다(규약 §16.243②) —
     * 메뉴 축과 옵션 축이 **같은 사실**인데 그 문장을 렌더하는 곳은 옵션 토글 하나였다.
     *
     * ★ 판정은 서버가 한다 — 배달 링크가 없는 매장이 대다수라(리얼 1,219곳 중 9곳) 무조건 띄우면
     * 존재하지 않는 숙제를 준다(§16.230). 조회 실패는 조용히 넘긴다.
     *
     * 배달 메뉴 조회 액션이 없는 세션(관리점·운영사 — R-E2 는 `/api/delivery-menu/**` 를 주지 않는다)은 **부르지
     * 않는다**: 보안 계층의 403 은 세션을 끝내고 `try/catch` 로는 막지 못한다. 매장 화면(`SMenuListForStoreView`
     * 의 `canViewDelivery`)과 같은 게이트다.
     */
    afterSaved: async function (message) {
      let note = ''
      if (
        this.inputForm.stopSelling &&
        this.inputForm.smenuCd &&
        this.checkAuthActionAccess(DELIVERY_MENU_ACTIONS.VIEW)
      ) {
        try {
          const res = await this.$axios.get(`/api/delivery-menu/menus/${this.inputForm.smenuCd}/soldout-platforms`)
          if (((res && res.data) || []).length) note = ' ' + this.$t(SOLD_OUT_PLATFORM_DEFAULT)
        } catch (e) {
          note = ''
        }
      }
      this.mainVue.$message(
        note
          ? { type: 'success', duration: 8000, showClose: true, message: message + note }
          : { type: 'success', message: message }
      )
      this.dialogFormVisible = false
      this.search()
    },
    // 이미지 선택
    smenuImgChange: function (file) {
      util.imgToBase64(
        URL.createObjectURL(file.raw),
        file.raw.type,
        function (data, img) {
          // 200x150이 아니면 메세지 표시
          if (200 != img.width || 150 != img.height) {
            this.mainVue.$message({ type: 'warning', message: this.$t('200x150 픽셀 이미지만 업로드 가능합니다.') })
          } else {
            this.inputForm.smenuImgFile = data
          }
        }.bind(this)
      )
    },
    searchDictionary: function (searchText) {
      this.mainVue.$axios.search(
        '/dictionary/search',
        { nm: this.searchText, dictionaryTpVal: 'menu' },
        function (result) {
          this.popTableData = []

          for (var i = 0, len = result.length; i < len; i++) {
            var tmp = result[i]

            tmp[result[i].lan.id] = result[i].nm

            for (var j = 0, jlen = result[i].dictionarys.length; j < jlen; j++) {
              tmp[result[i].dictionarys[j].lan.id] = result[i].dictionarys[j].nm
            }

            this.popTableData.push(tmp)
          }
        }.bind(this)
      )
    },
    // 키워드 데이타 선택
    selectDictionary: function (row) {
      for (var i = 0, len = this.lans.length; i < len; i++) {
        // 기본 언어 새팅
        if (0 == i) {
          this.inputForm.smenuNm = row[this.lans[i].id]
        } else {
          // 타언어 순서대로 등록
          this.inputForm.smenuInfos[i - 1].smenuInfoNm = row[this.lans[i].id]
        }
      }

      this.dictionaryDialogFormVisible = false
    },
    // 양식 다운로드
    downExcel: function () {
      const url = this.url + '/down/' + this.storeCd

      downloadExcelFile(url)
    },
    upSuccess: function () {
      this.mainVue.$message({ type: 'success', message: this.$t('업로드 되었습니다') })
      // 필터를 바꿨으니 **1페이지부터** 다시 본다
      this.searchForm.useYn = 'N'
      this.searchFirstPage()
    },
    upError: function () {
      this.mainVue.$message({ type: 'error', message: this.$t('업로드 실패 하였습니다') })
    },
    // 순서 수정
    handleChangeOrd: function (row) {
      this.mainVue.$axios.patchNonLoading(this.url + '/' + row.smenuCd + '/' + row.ord)
    },
  },
}
</script>

<style scoped>
.el-transfer-panel {
  width: 300px;
  height: 400px;
}

.el-transfer-panel__body {
  height: 354px;
}

.el-transfer-panel__list {
  height: 354px;
}

.el-transfer-panel__item {
  width: 240px;
}

.el-input-number__decrease,
.el-input-number__increase {
  background: white;
}
</style>
